import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;
export const BACKEND_URL = BASE;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});
